

import React,{useEffect,useState} from 'react'
import {useNavigate} from 'react-router-dom'
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import img from '../Assets/high_logo.png'
import Select from 'react-select';
import { base_url } from '../Services/api';
import Cookies from 'js-cookie'
import Lottie from 'lottie-react'
import loader from '../Animations/loader.json'


const GetHeaders = () => {

    const navigate = useNavigate();
    const [show,setShow] = useState(false);

       const [selectedOption, setSelectedOption] = useState({ value: 'daily', label: 'Tous les jours/100 FCFA' })
    const [loading,setLoading] = useState(false)
  const [tVal,setTVal] = useState(null)

  

    // const number = Cookies.get('number')
    

    const urlParams = new URLSearchParams(window.location.search);
    const msisdn = urlParams.get('msisdn');
    var ExtId = urlParams.get('extId');

   


      const Ext_params = urlParams.get('extId') 
        

    const getScript = async () => {
  if (window.__dcbScriptLoaded) return;

  // claim the lock immediately, before the async call starts —
  // otherwise a second fast invocation can slip through before
  // the first one ever sets the flag
  window.__dcbScriptLoaded = true;

  setLoading(true);

  try {

    const getScript = await axios.post(`${base_url}/api/v1/evina/script`, {
      serviceName: "HighFives",
      extId: Ext_params,
    })
    console.log(getScript,"==getscript--")
    console.log("script url--- ", JSON.parse(getScript.data.response).s);

    const scriptContent = await JSON.parse(getScript.data.response).s;
    console.log("response----- " + scriptContent);

    console.log("response " + scriptContent[100]);

    setTVal(JSON.parse(getScript.data.response)?.t)

    // Cookies.set('t', JSON.parse(getScript.data.response)?.t)

    ExtId =  await getScript.data.ti;

    if (scriptContent) {
      let top_head = document.getElementsByTagName("head")[0];
      let anti_script = document.createElement("script");

      anti_script.innerHTML = scriptContent;
      top_head.insertBefore(anti_script, top_head.firstChild);

      var event = new Event("DCBProtectRun");
      document.dispatchEvent(event);
      document.addEventListener("gateway-load", (event) => {
        console.log(event, "EVENT LOADED");
      });
    }

  } catch (error) {
    console.error("Error fetching script", error);
  } finally {
    setLoading(false);
    setShow(true);
  }
}


useEffect(()=>{
  getScript()
},[])

   const options = [
    { value: 'daily', label: 'Tous les jours/100 FCFA' },
    { value: 'weekly', label: 'Hebdomadaire/300 FCFA' },
    { value: 'monthly', label: 'Mensuelle/500 FCFA' },
  ];

      const customStyles = {
        control: (provided, state) => ({
          ...provided,
          borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray', // Change border color here
          boxShadow: state.isFocused ? '0 0 0 1px rgb(234 88 12)' : 'none', // Optional: Add box shadow
          '&:hover': {
            borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray', // Change border color on hover
          },
        
        }),
        // You can customize other parts of the select component as well
      };


      // const handle = async (e) => {
      //   e.preventDefault();
      //   setLoading(true)
    
      //   const data = {
      //     msisdn:msisdn,
      //     packType:selectedOption.value,
      //     extId:ExtId,
      //     t:tVal,
      //     serviceName:"HighFives"
      //   }
    
      //   try{
      //     const res = await axios.post(`${base_url}/api/v1/subscribe`,data);
      //     console.log(res.data);
    
      //     if(res.data?.statusCode === 200 || res.data?.code === 'SUCCESS'){
      //       toast.success(res.data?.message || 'Abonnement réussi !')
      //       setTimeout(()=>{
      //         // navigate('/home')
      //         window.location.href='https://highfivesgames.com/#/?op=orange'
      //       },1000)
            
      //     }
      //     else{
      //       toast.error(res.data?.message || "Échec de l'abonnement")
      //     }
    
    
      //   }
      //   catch(err){
      //     console.log(err,'error------in subscribing')

      //     const status = err?.response?.status;
      //     const msg = err?.response?.data?.message;

      //     if(status === 400){
      //       toast.error(msg || "Requête invalide, veuillez réessayer.")
      //     } else if(status === 500){
      //       toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.")
      //     } else {
      //       toast.error(msg || "Une erreur s'est produite")
      //     }
      //   }
    
      //   Cookies.set('number',msisdn);
      //   setLoading(false)
    
      //   // navigate('/otp-validation')
      // };


    const handle = async (e) => {
    e.preventDefault();
    setLoading(true)

    const data = {
      msisdn: msisdn,
      packType: selectedOption.value,
      extId: ExtId,
      t: tVal,
      serviceName: "HighFives"
    }

    try {
      const res = await axios.post(`${base_url}/api/v1/subscribe`, data);
      console.log(res.data);

      if (res.data?.statusCode === 200 && res.data?.code === 'SUCCESS') {
        toast.success(res.data?.message || 'Abonnement réussi !')

          Cookies.set('number',msisdn,{ expires: 6/24 });
  Cookies.set('extId',ExtId,{ expires: 6/24 })
        setTimeout(() => {
          window.location.href = 'https://highfivesgames.com/#/?op=orange'
        }, 1000)

      } else if (res.data?.statusCode === 200 && res.data?.code === 'BILLING_PENDING') {
        toast.info(res.data?.message || "Facturation en attente.");
      } else {
        toast.error(res.data?.message || "Échec de l'abonnement")
      }

    }
    catch (err) {
      console.log(err, 'error------in subscribing')

      const status = err?.response?.status;
      const msg = err?.response?.data?.message;
      const code = err?.response?.data?.code;

      if (status === 409 && code === 'ACTIVE_SUBSCRIPTION') {
        toast.info(msg || "Abonnement déjà actif.");
        setTimeout(() => {
          window.location.href = 'https://highfivesgames.com/#/?op=orange'
        }, 1000)
      } else if (status === 400) {
        toast.error(msg || "Requête invalide, veuillez réessayer.")
      } else if (status === 500) {
        toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.")
      } else {
        toast.error(msg || "Une erreur s'est produite")
      }
    }

    Cookies.set('number', msisdn);
    setLoading(false)

  };

  //   Cookies.set('number',msisdn);
  // Cookies.set('extId',ExtId)

  


  return (
    <div className="fixed inset-0 overflow-y-auto bg-black/90 flex justify-center items-center z-10">
    {
      show ? 
      <>
      <div className="container mx-auto max-w-screen-sm bg-white rounded-md p-4 md:p-8 flex flex-col items-center shadow-lg relative">
      <img
        src={img}
        alt="/"
        className="w-24 h-auto mb-4 md:mb-0 md:w-[200px]"
      />
      <form className="flex flex-col w-full md:w-2/3 px-4 py-4 md:py-8">
        <div className="text-center">
          <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">
           
              
          Sélectionnez le
 
           
            <span className="text-orange-600 font-bold text-2xl md:text-3xl px-2">
            Type de paquet
            </span>
          </h1>
        </div>
        {/* <br /> */}
        <p className='py-2 pt-4 text-lg font-semibold'>Type de paquet</p>
        <Select
      defaultValue={selectedOption}
      onChange={setSelectedOption}
      options={options}
      styles={customStyles}
    />
        {/* {error && <p className="text-red-600 text-center mt-2">{error}</p>} */}
        <div className="flex mt-4 md:mt-6">
          <button
            id="otp-send"
            onClick={handle}
            type='submit'
            className="w-full bg-orange-600 text-white py-2 px-4 rounded"
            disabled={loading}
          >
            {loading ? "Soumission..." : "Soumettre"}
          </button>
        </div>
     
      </form>
          <p
  onClick={() => navigate('/tnc')}
  className="text-black text-center mb-3 underline cursor-pointer"
>
  Conditions générales
</p>

<div className="w-full md:w-[80%] mx-auto px-4 text-center">
  <p className="text-xs font-semibold break-words">
    • Désinscription gratuite à tout moment : composez #303#10#.
  </p>

  <p className="text-xs font-semibold break-words mt-2">
    • Pour toute question ou assistance, veuillez contacter notre service
    client ou visiter notre page d'assistance, c'est-à-dire{" "}
    <a
      href="mailto:panz.support1@panzcon.com"
      className="underline text-blue-300"
    >
      panz.support1@panzcon.com
    </a>
  </p>
</div>
    </div>
      </>
      :
      <>
        <Lottie
          animationData={loader}
        />
      </>
      

    }
  </div>
  )
}

export default GetHeaders






//working

// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Cookies from "js-cookie";
// import Select from "react-select";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Lottie from "lottie-react";

// import img from "../Assets/high_logo.png";
// import loader from "../Animations/loader.json";
// import { base_url } from "../Services/api";
// import classes from './Subscribe.module.css'


// const GetHeaders = () => {

//   const navigate = useNavigate();

//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [tVal, setTVal] = useState(null);

//   const scriptLoaded = useRef(false);

//     const [selectedOption, setSelectedOption] = useState({ value: 'daily', label: 'Tous les jours/100 FCFA' })

//   const urlParams = new URLSearchParams(window.location.search);

//   const msisdn = urlParams.get("msisdn");
//   const ExtId = urlParams.get("extId");

//   Cookies.set("number", msisdn || "");
//   Cookies.set("extId", ExtId || "");

//   const options = [
//     { value: 'daily', label: 'Tous les jours/100 FCFA' },
//     { value: 'weekly', label: 'Hebdomadaire/300 FCFA' },
//     { value: 'monthly', label: 'Mensuelle/500 FCFA' },
//   ];

//   const customStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       borderColor: state.isFocused ? "rgb(234 88 12)" : "gray",
//       boxShadow: state.isFocused
//         ? "0 0 0 1px rgb(234 88 12)"
//         : "none",
//     }),
//   };

//   // LOAD SCRIPT





// // useEffect(() => {

// //   if (scriptLoaded.current) return;

// //   // set this BEFORE the async call, not after it resolves
// //   scriptLoaded.current = true;

// //   const loadScript = async () => {

// //     try {

// //       setLoading(true);

// //       const res = await axios.post(
// //         `${base_url}/api/v1/evina/script`,
// //         {
// //           serviceName: "HighFive",
// //           extId: ExtId,
// //         }
// //       );

// //       // console.log(res, "==response==")

// //       // the real payload is nested one level deeper, inside res.data.response,
// //       // and that nested field is itself a stringified JSON object
// //       const outer = res.data;
// //       const inner = typeof outer?.response === 'string'
// //         ? JSON.parse(outer.response)
// //         : outer?.response;

// //       // console.log(inner, "==parsed==")

// //       const scriptContent = inner?.s;
// //       const token = inner?.t;

// //       // console.log(token, "==token==")

// //       if (token) {
// //         Cookies.set('t', token);
// //       }

// //       setTVal(token || "");

// //       if (!scriptContent) {
// //         console.log("No script content found");
// //         return;
// //       }

// //       const existingScript = document.getElementById("dcb-script");

// //       if (!existingScript) {

// //         const script = document.createElement("script");

// //         script.id = "dcb-script";
// //         script.type = "text/javascript";
// //         script.innerHTML = scriptContent;

// //         document.head.appendChild(script);

// //         document.dispatchEvent(new Event("DCBProtectRun"));

// //         // console.log("Script loaded successfully");
// //       }

// //     } catch (err) {
// //       console.log("SCRIPT ERROR", err);

// //       const status = err?.response?.status;
// //       const msg = err?.response?.data?.message;

// //       if (status === 400) {
// //         console.log("Invalid script request payload:", msg);
// //       } else if (status === 500) {
// //         console.log("Server error generating script:", msg);
// //       }

// //       // if the call failed, allow a retry on next mount
// //       scriptLoaded.current = false;

// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   loadScript();

// // }, []);

// useEffect(() => {

//   if (scriptLoaded.current) return;

//   // set this BEFORE the async call, not after it resolves
//   scriptLoaded.current = true;

//   const loadScript = async () => {

//     try {

//       setLoading(true);

//       const res = await axios.post(
//         `${base_url}/api/v1/evina/script`,
//         {
//           serviceName: "HighFives",
//           extId: ExtId,
//         }
//       );

//       const outer = res.data;
//       const inner = typeof outer?.response === 'string'
//         ? JSON.parse(outer.response)
//         : outer?.response;

//       const scriptContent = inner?.s;
//       const token = inner?.t;

//       if (token) {
//         Cookies.set('t', token);
//       }

//       setTVal(token || "");

//       if (!scriptContent) {
//         console.log("No script content found");
//         return;
//       }

//       const existingScript = document.getElementById("dcb-script");

//       if (!existingScript) {

//         const script = document.createElement("script");

//         script.id = "dcb-script";
//         script.type = "text/javascript";
//         script.innerHTML = scriptContent;

//         document.head.appendChild(script);

//         document.dispatchEvent(new Event("DCBProtectRun"));
//       }

//     } catch (err) {
//       console.log("SCRIPT ERROR", err);

//       const status = err?.response?.status;
//       const msg = err?.response?.data?.message;

//       if (status === 400) {
//         console.log("Invalid script request payload:", msg);
//       } else if (status === 500) {
//         console.log("Server error generating script:", msg);
//       }

//       // if the call failed, allow a retry on next mount
//       scriptLoaded.current = false;

//     } finally {

//       setLoading(false);
//       setShow(true);   // ← the fix: reveal the form once loading is done
//     }
//   };

//   loadScript();

// }, []);


 


//   // SUBMIT
// // const handle = async (e) => {

// //   e.preventDefault();

// //   try {

// //     setLoading(true);

// //     const data = {
// //       msisdn,
// //       packType: selectedOption.value,
// //       extId: ExtId,
// //       t: tVal,
// //       serviceName: "HighFive",
// //     };

// //     // console.log("SUBMIT DATA", data);

// //     const res = await axios.post(
// //       `${base_url}/api/v1/subscribe`,
// //       data
// //     );

// //     // console.log(res.data);

// //     if (res.data?.statusCode === 200 || res.data?.code === 'SUCCESS') {
// //       toast.success(res.data?.message || "Subscribed Successfully");


// //       setTimeout(() => {

// //         window.location.href =
// //           "https://highfivesgames.com/#/?op=orange";

// //       }, 1000);

// //     } else {

// //       toast.error(res.data?.message || "Subscription failed");
// //     }

// //   } catch (err) {

// //     console.log(err);

// //     const status = err?.response?.status;
// //     const msg = err?.response?.data?.message;

// //     if (status === 400) {
// //       toast.error(msg || "Requête invalide, veuillez réessayer.");
// //     } else if (status === 500) {
// //       toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
// //     } else {
// //       toast.error(msg || "Something went wrong");
// //     }

// //   } finally {

// //     setLoading(false);
// //   }
// // };

// const handle = async (e) => {

//   e.preventDefault();

//   try {

//     setLoading(true);

//     const data = {
//       msisdn,
//       packType: selectedOption.value,
//       extId: ExtId,
//       t: tVal,
//       serviceName: "HighFives",
//     };

//     const res = await axios.post(
//       `${base_url}/api/v1/subscribe`,
//       data
//     );

//     if (res.data?.statusCode === 200 || res.data?.code === 'SUCCESS') {

//       toast.success(res.data?.message || "Subscribed Successfully");

//       setTimeout(() => {

//         window.location.href =
//           "https://highfivesgames.com/#/?op=orange";

//       }, 1000);

//     } else {

//       toast.error(res.data?.message || "Subscription failed");
//     }

//   } catch (err) {

//     console.log(err);

//     const status = err?.response?.status;
//     const msg = err?.response?.data?.message;

//     if (status === 400) {
//       toast.error(msg || "Requête invalide, veuillez réessayer.");
//     } else if (status === 500) {
//       toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
//     } else {
//       toast.error(msg || "Something went wrong");
//     }

//   } finally {

//     setLoading(false);
//   }
// };

//   return (
//     <div className="fixed inset-0 overflow-y-auto bg-black/90 flex justify-center items-center z-10">

//       {
//         show ? (
//           <>
//             <div className="container mx-auto max-w-screen-sm bg-white rounded-md p-4 md:p-8 flex flex-col items-center shadow-lg relative">

//               <img
//                 src={img}
//                 alt=""
//                 className="w-24 h-auto mb-4 md:w-[200px]"
//               />

//               <form className="flex flex-col w-full md:w-2/3 px-4 py-4 md:py-8">

//                 <div className="text-center">

//                   <h1 className="text-2xl md:text-3xl font-bold mb-4">

//                     Sélectionnez le

//                     <span className="text-orange-600 px-2">
//                       Type de paquet
//                     </span>

//                   </h1>

                  

//                 </div>
//                 <div>
//                    <p  className="text-center w-[90%] font-bold" >HighFive est un portail de jeux proposant des jeux amusants et captivants de différents genres pour les joueurs de tous niveaux.</p>
//                 </div>
               

//                 <p className="py-2 pt-4 text-lg font-semibold">
//                   Type de paquet
//                 </p>

//                 <Select
//                   defaultValue={selectedOption}
//                   onChange={setSelectedOption}
//                   options={options}
//                   styles={customStyles}
//                 />

//                 <div className="flex mt-4">

//                   <button
//                     onClick={handle}
//                     type="submit"
//                     className="w-full bg-orange-600 text-white py-2 px-4 rounded"
//                     disabled={loading}
//                   >
//                     {loading ? "Soumission..." : "Soumettre"}
//                   </button>

                  

//                 </div>

//                  <div >
//     <span className='text-xs font-semibold w-full text-center' >• Désinscription gratuite à tout moment : composez #303#10#.</span>
//     <br/>
//         <span className='text-xs font-semibold w-full text-center' >• Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>
//         </div>

             

//               </form>

//             </div>

//             <ToastContainer />
//           </>
//         ) : (
//           <Lottie animationData={loader} />
//         )
//       }

//     </div>
//   );
// };

// export default GetHeaders;
